import kfetch from '@kareo/kfetch';
import rollbar from 'shared-assets/src/errors/errors';

/**
 * @constant
 * @type {string}
 */
export const PRODUCTS_BY_EDITION_TYPE_URL =
  '/product-setup-ui/api/ProductSetup/products/preselected';

/**
 * @constant
 * @type {string}
 */
export const PRACTICE_SETUP_STATE_URL =
  '/product-setup-ui/api/ProductSetup/practice/setupstate';

const Products = {
  /**
   * Return the list of ids of the products included with the edition type id.
   * @async
   * @function getProductsByEditionTypeId
   * @return {array of int} - Returns a list of products included in the edition type
   */
  getPreselectedProductsByEditionType: async () => {
    try {
      const res = await kfetch(PRODUCTS_BY_EDITION_TYPE_URL);
      // Store the value in the session storage.
      if (res !== null) {
        return res;
      }
      // If the response is not correct then return an empty array
      return [];
    } catch (err) {
      rollbar.error(err);
      // In case we find an error then it should return an empty array
      return [];
    }
  },

  /**
   * Returns the practiceSetupState.
   * @async
   * @function getPracticeSetupState
   * @return {string} - Returns the practiceSetupState
   */
  getPracticeSetupState: async () => {
    try {
      return await kfetch(PRACTICE_SETUP_STATE_URL);
    } catch (err) {
      rollbar.error(err);
      // In case we find an error then it should return an empty string
      return '';
    }
  },

  /**
   * Upserts the practiceSetupState.
   * @async
   * @function upsertPracticeSetupState
   */
  upsertPracticeSetupState: async practiceSetupState => {
    try {
      kfetch(`${PRACTICE_SETUP_STATE_URL}/${practiceSetupState}`, {
        method: 'PUT',
      });
    } catch (err) {
      rollbar.error(err);
    }
  },
};

export default Products;
